import { jFileLittle } from 'jamespot-user-api';

/*
    width: width of the input image
    height: height of the input image
    maxWidth: max width of the ouput image (set to zero to avoid resize)
    maxHeight: max height of the ouput image (set to zero to avoid resize)
*/
export function imageResize(
    width: number,
    height: number,
    maxWidth: number,
    maxHeight: number,
): { width: number; height: number } {
    let outputWidth = width;
    let outputHeight = height;
    let r = 1;

    if (width > maxWidth && maxWidth !== 0) {
        r = maxWidth / width;
        outputWidth = maxWidth;
        outputHeight = Math.round(height * r);
    }
    if (height > maxHeight && maxHeight !== 0) {
        r = maxHeight / height;
        outputWidth = Math.round(width * r);
        outputHeight = maxHeight;
    }

    return { width: outputWidth, height: outputHeight };
}

export const mockFileLittle = (): jFileLittle => {
    return {
        id: Math.round(Math.random() * 1000),
        type: '',
        title: 'this_is_a_mock.txt',
        uri: '',
        mimetype: 'application/octet-stream',
        mainType: '',
        dateCreation: new Date().toISOString(),
        dateModified: new Date().toISOString(),
        _url: '',
        size: 10,
    };
};
